import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'

import WebsolutionsSidebar from '../../../components/WebsolutionsSidebar'
import BranddevelopmentSidebar from '../../../components/BranddevelopmentSidebar'
import DigitalmarketingSidebar from '../../../components/DigitalmarketingSidebar'

import Fill from '../../../images/Fill.svg'
import Divider from '../../../images/Divider.svg'

export const query = graphql`
  query iam {
    iambanner: imageSharp(id: {regex: "/images/Thor.jpg/"}) {
      sizes(quality: 75, maxWidth: 1000, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}, toFormat: PNG) {tracedSVG src}
    },
}
`

const InfluencersMarketing = ({data:{iambanner}}) => (
  <section>
    <article className='container'>
    <div className='full-Width' style={{alignItems:'flex-start'}}>
      <div className='half-Width-75 paddingRight mobBottommargin'>
        <div style={{display:'block'}}>
          <h1 className='smallerHone'>Influencers and Affiliated Marketing</h1>
          <img src={Divider} alt="Nisadhya - Divider" style={{margin:'0.75rem 0'}}/>
          <p className='smallerHone'><span className='gradient'>Case studies such as these inspire and motivate us.</span></p>
          <p>See how businesses similar to yours are growing with Digital Marketing.</p>
          <div style={{backgroundImage:`url("${iambanner.sizes.src}"), url("${iambanner.sizes.tracedSVG}")`, backgroundPosition:'center', backgroundSize:'cover', minHeight:'50vh', marginBottom:'1.45rem'}}>
          </div>
          <p style={{marginBottom:'0'}}>What your brand needs is not the ‘biggest’ influencers but the ‘right’ influencers that will endorse your search visibility, brand awareness and engagement.
          We ensure that your brand works with the ‘right’ people to use their influence and mention your brand to potential customers to form a mutually beneficial relationship.</p>
        </div>
      </div>
      <div className='half-Width-25 service-sidebar'>
        <div style={{marginBottom:'2.5rem'}}><DigitalmarketingSidebar /></div>
        <div style={{marginBottom:'2.5rem'}}><WebsolutionsSidebar /></div>
        <div><BranddevelopmentSidebar /></div>
      </div>
    </div>
    </article>
  </section>
)

export default InfluencersMarketing



// WEBPACK FOOTER //
// ./src/pages/services/digital-marketing/influencers-and-affiliated-marketing.js